import Scrolling from './scrolling';
import Util from './util';

/* global gtm */
const Tracking = {
	Init() {
		// Offsite links
		$(document).on('click', 'a[href^="http"]:not(.disable-tracking)', e => {
			const $target = $(e.target);
			Tracking.TrackEvent('Navigation', 'Offsite', $target.attr('title') || $target.attr('href'));
		});

		// Tap to call (tel:)
		$(document).on('click', 'a[href^="tel:"]:not(.disable-tracking)', e => {
			Tracking.TrackEvent('Navigation', 'Tap to Call', $(e.target).attr('href'));
		});

		// Click to email (mailto:)
		$(document).on('click', 'a[href^="mailto:"]:not(.disable-tracking)', e => {
			Tracking.TrackEvent('Navigation', 'Email', $(e.target).attr('href'));
		});

		// Downloads
		$(document).on(
			'click',
			'a[href^="/documents/"]:not(.disable-tracking), a[href^="https://ddph-healthydelaware.s3"]:not(.disable-tracking)',
			e => {
				Tracking.TrackEvent('Navigation', 'Download', $(e.target).attr('href'));
			}
		);

		// Conversions (Google Ads)
		$('[data-track-conversion]').each(() => {
			Tracking.TrackAdWordsConversion(
				`${$('body').data('google-ads-conversionid')}/${$('body').data('google-ads-conversionlabel')}`
			);
		});

		// Tracking pixels
		$(document).on('click', '[data-track-pixel]:not(form)', e => {
			Tracking.TrackPixel($(e.target).data('track-pixel'));
		});

		// Track anchor
		$(document).on('click', '.track-anchor', e => {
			const $anchor = $(e.target);
			Tracking.TrackEvent($anchor.data('event-category'), $anchor.data('event-action'), $anchor.attr('href'));
		});

		// Track accordion
		$('.accordion').on('click', 'a.collapsed', e => {
			const $anchor = $(e.target);

			Tracking.TrackEvent('Navigation', 'Accordion Open', $anchor.attr('href'));
			Util.UpdateUrlHash($anchor.attr('href'));

			setTimeout(() => {
				Scrolling.scroller.intoView(e.target);
			}, 500);
		});
	},
	TrackPixel(href) {
		if (href !== undefined) {
			const evp = document.createElement('img');
			evp.height = 1;
			evp.width = 1;
			evp.style.display = 'none';
			evp.src = href;
			document.body.appendChild(evp);
		}
	},
	TrackPageView(href) {
		if (Tracking.IsDataLayerAvailable()) {
			try {
				window.dataLayer.push({
					event: 'VirtualPageView',
					page_path: href
				});
			} catch (e) { } // eslint-disable-line
		}

		if (Tracking.IsGtagAvailable()) {
			try {
				/* eslint-disable-next-line no-undef */
				gtag('config', $('body').data('google-analytics-propertyid'), { page_path: href });
			} catch (e) { } // eslint-disable-line
		} else {
			try {
				/* eslint-disable-next-line no-undef */
				ga('send', 'pageview', href);
			} catch (e) { } // eslint-disable-line
		}
	},
	TrackEvent(category, action, label, value) {
		if (Tracking.IsDataLayerAvailable()) {
			try {
				window.dataLayer.push({
					event: 'Event',
					category,
					action,
					label,
					value
				});
			} catch (e) { } // eslint-disable-line
		}

		if (Tracking.IsGtagAvailable()) {
			try {
				/* eslint-disable-next-line no-undef */
				gtag('event', action, {
					event_category: category,
					event_label: label,
					value
				});
			} catch (e) { } // eslint-disable-line
		} else {
			try {
				/* eslint-disable-next-line no-undef */
				ga('send', 'event', category, action, label, value);
			} catch (e) { } // eslint-disable-line
		}
	},
	TrackAdWordsConversion(sendTo, value, currency) {
		if (Tracking.IsGtagAvailable()) {
			try {
				if (typeof value !== 'undefined') {
					// eslint-disable-next-line no-undef
					gtag('event', 'conversion', {
						send_to: sendTo,
						value,
						currency
					});
				} else {
					// eslint-disable-next-line no-undef
					gtag('event', 'conversion', {
						send_to: sendTo
					});
				}
			} catch (e) { } // eslint-disable-line
		}
	},
	IsGtagAvailable() {
		return typeof gtag !== 'undefined';
	},
	IsDataLayerAvailable() {
		return typeof window.dataLayer !== 'undefined';
	}
};

export default Tracking;
